import { useMemo } from 'react';
import { Station } from 'entities/stations';
import { useGetStationByCode } from 'entities/stations';
import { getStationIconSettings } from 'common/utils/index';

export const useStationIcon = (stationCode: Station['code']) => {
  const getStationByCode = useGetStationByCode();

  const stationIcon = useMemo(() => {
    const { categoryCode, roadsideServiceCodes = [] } = getStationByCode(stationCode) || {};
    const { icon, iconColor = ''} = getStationIconSettings(categoryCode, roadsideServiceCodes);

    return { icon, iconColor };
  }, [stationCode, getStationByCode]);

  return stationIcon;
};
